<template>
  <div class="ruleconfiguration">
    <!--标题-->
    <div class="title">新增考勤组</div>
    <!--内容-->
    <div class="content">
      <!--名称-->
      <div class="item">
        <div class="label"><span class="must">*</span>名<span class="txthidden">占位</span>称：</div>
        <el-input v-model="formData.name" placeholder="请输入内容" style="width: 250px;"></el-input>
      </div>
      <!--考勤人员-->
      <div class="item">
        <div class="label"><span class="must">*</span>考勤人员：</div>
        <el-button @click="clickPeople">请选择</el-button>
        <div v-if="formData.employeeIds.length>0" style="line-height: 30px;">已添加{{formData.employeeIds.length}}人</div>
      </div>
      <!--考勤时间-->
      <div class="item">
        <div class="label"><span class="must">*</span>考勤时间：</div>
        <div>
          <el-table :data="formData.timeDTO" :header-cell-style="setHeaderStyle" border style="width: 602px;max-width: 602px;min-width: 602px;margin-bottom: 10px;">
            <el-table-column label="考勤时间" width="200">
              <template slot-scope="scope">
                <span>{{scope.row.upFirstTime}}-{{scope.row.downFirstTime}}</span>
                <span v-if="formData.timeDTO[0].punchNumber=='4'">&nbsp;{{scope.row.upSecondTime}}-{{scope.row.downSecondTime}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="attendanceDay" label="工作日" width="300"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <div @click="modification(scope.row)" style="color: #5E75E6;cursor: pointer">修改</div>
              </template>
            </el-table-column>
          </el-table>
          <el-checkbox v-model="formData.whetherHoliday">法定节假日自动排休</el-checkbox>
        </div>
      </div>
      <!--特殊日期-->
      <div class="item">
        <div class="label no">特殊日期：</div>
        <!--必须打卡日期-->
        <div>
          <div>
            <el-button @click="dialogVisibleClockinDate=true;clockinDateTitle='必须打卡日期';clockinDate=''">添加</el-button>
            必须打卡日期
          </div>
          <el-table :data="formData.mustDays" :header-cell-style="setHeaderStyle" border style="width: 272px;max-width: 272px;min-width: 272px;margin-top: 10px;">
            <el-table-column label="日期" width="135">
              <template slot-scope="scope">
                <div>{{scope.row}}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="135">
              <template slot-scope="scope">
                <div @click="handleClick(scope)" style="color: #FF0000;cursor: pointer">删除</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--无须打卡日期-->
        <div style="margin-left: 60px;">
          <div>
            <el-button @click="dialogVisibleClockinDate=true;clockinDateTitle='无须打卡日期';clockinDate=''">添加</el-button>
            无须打卡日期
          </div>
          <el-table :data="formData.notDays" :header-cell-style="setHeaderStyle" border style="width: 272px;max-width: 272px;min-width: 272px;margin-top: 10px;">
            <el-table-column label="日期" width="135">
              <template slot-scope="scope">
                <div>{{scope.row}}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="135">
              <template slot-scope="scope">
                <div @click="handleClick1(scope)" style="color: #FF0000;cursor: pointer">删除</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!--考勤地点-->
      <div class="item">
        <div class="label no" style="margin-top: 2px">考勤地点：</div>
        <div>
          <div style="margin-bottom: 8px;">
            <el-radio v-model="formData.spaceSetting" label="NO">考勤人员所属部门地址 (如果所属部门为组，考勤地址为组所属的门店）</el-radio>
          </div>
<!--          <div style="margin-bottom:8px;">-->
          <div >
            <el-radio v-model="formData.spaceSetting" label="YES">自定义考勤</el-radio>
          </div>
          <div v-if="formData.spaceSetting==='YES'" style="margin-top: 8px;">
            <div class="fanwei">
              <div><span style="color: #5E75E6;cursor: pointer;" @click="dialogVisibleAddress=true">新增考勤地址</span>（可添加多个）
              </div>
<!--              <div>有效范围：<el-input v-model="formData.spaceRange" style="width: 50px;margin-right: 6px;"></el-input>米-->
<!--              </div>-->
            </div>
            <el-table :data="formData.spaceDTO" :header-cell-style="setHeaderStyle" border style="width: 602px;max-width: 602px;min-width: 602px;">
              <el-table-column prop="space" label="考勤地点" width="470"></el-table-column>
              <el-table-column label="操作" width="130">
                <template slot-scope="scope">
                  <div @click="deleteAddress(scope)" style="color: #FF0000;cursor: pointer">删除</div>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </div>
      </div>
      <div class="item">
        <div style="margin-left: 7.28px">有效范围：<el-input v-model="formData.spaceRange" style="width: 80px;margin-right: 6px;"></el-input>米</div>
      </div>
      <!--考勤设置-->
      <div class="item">
        <div class="label no" style="margin-top: 2px;">考勤设置：</div>
        <el-checkbox-group v-model="formData.pcOrApp">
          <el-checkbox label="PC">开启电脑端打卡</el-checkbox>
          <el-checkbox label="APP">开启手机端打卡</el-checkbox>
        </el-checkbox-group>
      </div>
      <!--提前请假-->
      <div class="item">
        <div class="label no" style="margin-top: 2px;">提前请假：</div>
        <el-input v-model="formData.advanceHourHoliday" style="width: 80px;margin-right: 6px;"></el-input>
        <span>小时</span>
        <span style="color: #FF8400;margin-left: 30px;">注：0或者空为无限制</span>
      </div>
      <!--延后请假-->
      <div class="item">
        <div class="label no" style="margin-top: 2px;">延后请假：</div>
        <el-input v-model="formData.delayHourHoliday" style="width: 80px;margin-right: 6px;"></el-input>
        <span>小时</span>
        <span style="color: #FF8400;margin-left: 30px;">注：0或者空为无限制</span>
      </div>
      <!--延后补卡-->
      <div class="item">
        <div class="label no" style="margin-top: 2px;">延后补卡：</div>
        <el-input v-model="formData.delayHourCard" style="width: 80px;margin-right: 6px;"></el-input>
        <span>小时</span>
        <span style="color: #FF8400;margin-left: 30px;">注：0或者空为无限制</span>
      </div>
      <!--外勤设置-->
      <div class="item">
        <div class="label no" style="margin-top: 2px;">外勤设置：</div>
        <el-checkbox-group v-model="formData.fieldSetup">
          <el-checkbox :label=1>允许外勤打卡</el-checkbox>
<!--          <span v-if="formData.fieldSetup.indexOf(1)!==-1">-->
<!--            <el-checkbox :label=2>外勤打卡需填写备注</el-checkbox>-->
<!--            <el-checkbox :label=3>外勤打卡需拍照</el-checkbox>-->
<!--          </span>-->
        </el-checkbox-group>
      </div>
      <!--其他设置-->
      <div class="item">
        <div class="label no" style="margin-top: 2px;">其他设置：</div>
        <div>
          <el-checkbox v-model="formData.offWork">下班无需打卡</el-checkbox>
          <span style="color: #FF8400">注：勾选之后，下班不打卡视为出勤</span>
        </div>
      </div>

    </div>

    <!--取消保存-->
    <div class="foot">
      <button class="cancel1" @click="cancel">取消</button>
      <button class="save" @click="agreeOrnot">保存</button>
    </div>
    <!----------********!!!!!!!!!!!!!!!!!!!!!!!!!!弹框!!!!!!!!!!!!!!!!!!!!!!!!*********--------->
    <!--选择考勤人员-->
    <el-dialog title="选择考勤人员" :before-close='handleClose' :visible.sync="dialogTableVisible" v-if="dialogTableVisible" width="490px">
      <div class="out1">
        <div class="tree-title">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
          <div>已添加{{employeeIds.length}}人</div>
        </div>
        <div class="tree_out">
          <el-tree class="filter-tree" :data="attendancePerson" :props="defaultProps" default-expand-all :filter-node-method="filterNode" @node-click="choicePerson" ref="tree">
          </el-tree>
          <!--已选考勤人员-->
          <div class="selected">
            <div class="selected-item" v-for="(item,index) in employeeIds" :key="index"><span style="width: 160px;">{{item.name}}</span><i @click="deleteAttendancePerson(index)" class="iconfont icon-guanbi"></i></div>
          </div>
        </div>
      </div>
      <!--取消、确定按钮-->
      <div class="dialog-foot">
        <button class="foot-cancel" @click="addPersonCancel">取消</button>
        <button class="foot-save" @click="addPerson">确定</button>
      </div>
    </el-dialog>
    <!--编辑考勤时间-->
    <el-dialog title="编辑考勤时间" :visible.sync="dialogVisible" v-if="dialogVisible" width="650px">
      <div class="dateOut">
        <!--工作日-->
        <div class="item">
          <div class="label"><span class="must">*</span>工作日：</div>
          <el-checkbox-group v-model="timeDTO.attendanceDay">
            <el-checkbox label="周一">周一</el-checkbox>
            <el-checkbox label="周二">周二</el-checkbox>
            <el-checkbox label="周三">周三</el-checkbox>
            <el-checkbox label="周四">周四</el-checkbox>
            <el-checkbox label="周五">周五</el-checkbox>
            <el-checkbox label="周六">周六</el-checkbox>
            <el-checkbox label="周日">周日</el-checkbox>
          </el-checkbox-group>
        </div>
        <!--每日打卡次数-->
        <div class="item">
          <div class="label"><span class="must">*</span>每日打卡次数：</div>
          <el-radio-group v-model="timeDTO.punchNumber">
            <el-radio-button label="2">一天两次打卡</el-radio-button>
            <el-radio-button label="4">一天四次打卡</el-radio-button>
          </el-radio-group>
        </div>
        <!--打卡时间-->
        <div class="item" style="align-items: flex-start">
          <div class="label" style="margin-top: 6px;"><span class="must">*</span>打卡时间：</div>
          <div>
            <!--第一次打卡-->
            <div>
              <span class="clockin">
                <span>上班：</span>
                <el-time-picker format="HH:mm" value-format="HH:mm" v-model="timeDTO.upFirstTime" placeholder="请选择">
                </el-time-picker>
              </span>
              <span class="clockout">
                <span>下班：</span>
                <el-time-picker format="HH:mm" value-format="HH:mm" v-model="timeDTO.downFirstTime" placeholder="请选择">
                </el-time-picker>
              </span>
            </div>
            <!--第二次打卡-->
            <div v-if="timeDTO.punchNumber=='4'" style="margin-top: 10px;">
              <span class="clockin">
                <span>上班：</span>
                <el-time-picker format="HH:mm" value-format="HH:mm" v-model="timeDTO.upSecondTime" placeholder="请选择">
                </el-time-picker>
              </span>
              <span class="clockout">
                <span>下班：</span>
                <el-time-picker format="HH:mm" value-format="HH:mm" v-model="timeDTO.downSecondTime" placeholder="请选择">
                </el-time-picker>
              </span>
            </div>
          </div>

        </div>
        <!--加班规则-->
        <div class="item">
          <div class="label">加班规则：</div>
          <div>
            <span>下班后</span>
            <el-select v-model="timeDTO.addRole" placeholder="请选择">
              <el-option v-for="(item,index) in addRole" :key="index" :label="item.valueDesc" :value="item.value">
              </el-option>
            </el-select>
            <span>计算加班时长（最小单位0.5小时）</span>
          </div>
        </div>
        <!--打卡时间限制-->
        <div class="item">
          <div class="label">打卡时间限制：</div>
          <div>
            <span>上班前</span>
            <el-select v-model="timeDTO.timeLimit" placeholder="请选择">
              <el-option v-for="(item,index) in timeLimit" :key="index" :label="item.valueDesc" :value="item.value">
              </el-option>
            </el-select>
            <span>允许打卡</span>
          </div>
        </div>
        <!--弹性时间-->
        <div class="item">
          <div class="label">弹性时间：</div>
          <div>
            <span>允许迟到时间</span>
            <el-input class="dlatetime" v-model="timeDTO.allowLate" placeholder="请输入"></el-input>
            <span>分钟</span>
          </div>
        </div>
      </div>
      <!--取消、确定按钮-->
      <div class="dialog-foot">
        <button class="foot-cancel" @click="dialogVisible=false">取消</button>
        <button class="foot-save" @click="getDate">确定</button>
      </div>
    </el-dialog>
    <!--添加必须的打卡日期/添加无须打卡日期-->
    <el-dialog :title="'添加'+ clockinDateTitle" :visible.sync="dialogVisibleClockinDate" v-if="dialogVisibleClockinDate" width="380px">
      <div class="clockinout">
        <span class="label">{{clockinDateTitle}}：</span>
        <span class="block">
          <el-date-picker v-model="clockinDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
          </el-date-picker>
        </span>
      </div>
      <!--取消、确定按钮-->
      <div class="dialog-foot">
        <button class="foot-cancel" @click="dialogVisibleClockinDate=false">取消</button>
        <button class="foot-save" @click="getClockinDate">确定</button>
      </div>
    </el-dialog>
    <!--设置考勤地点-->
    <el-dialog title="设置考勤地点" :visible.sync="dialogVisibleAddress" v-if="dialogVisibleAddress" width="760px">
      <addressAlert v-on:AddAlertremoveBtn="elDialogRemove" v-on:AddAlertSaveBtn="elDialogSave"></addressAlert>
    </el-dialog>

  </div>
</template>

<script>
import addressAlert from "../../components/common/addressAlert";
import {
  departmentFind,
  addRule,
  updateRule,
  queryRuleDetail
} from "@/api/checkingIn";
import { dicGet } from "@/api/index";
export default {
  name: "ruleConfiguration",
  components: {
    addressAlert
  },
  data() {
    return {
      url: addRule,
      //新增数据
      formData: {
        name: "", //名称
        employeeIds: [], //已选考勤人员
        //考勤时间表格数据
        timeDTO: [
          {
            attendanceDay: "周一,周二,周三,周四,周五", //工作日
            punchNumber: "2", //每日打卡次数
            upFirstTime: "09:00", //第一次上班打卡时间
            downFirstTime: "18:00", //第一次下班打卡
            upSecondTime: "", //第二次上班打卡时间
            downSecondTime: "", //第二次下班打卡
            addRole: "NO", //加班规则设置
            timeLimit: "ANY_TIME", //打卡时间限制
            allowLate: "" //允许迟到时间
          }
        ],
        whetherHoliday: false, //法定节假日自动排休
        mustDays: [], //必须打卡日期表格数据
        notDays: [], //无须打卡日期表格数据
        spaceSetting: "NO", //考勤地点选择项
        spaceRange: 100, //有效范围
        spaceDTO: [], //考勤地点表格数据
        pcOrApp: [], //考勤设置
        fieldSetup: [], //外勤设置
        offWork: false, //下班无需打卡
        advanceHourHoliday: 0,
        delayHourHoliday: 0,
        delayHourCard: 0,
      },
      dialogTableVisible: false, //选择考勤人员弹框
      dialogVisible: false, //编辑考勤时间弹框
      dialogVisibleAddress: false, //设置地点弹框
      dialogVisibleClockinDate: false, //设置特殊日期弹框
      filterText: "", //搜索考勤人员
      //考勤人员
      attendancePerson: [],
      employeeIds: [], //选择考勤人员
      //考勤人员树配置选项
      defaultProps: {
        children: "child",
        label: "name"
      },
      //编辑考勤时间
      timeDTO: {
        attendanceDay: [], //工作日
        punchNumber: "", //每日打卡次数
        upFirstTime: "", //第一次上班打卡时间
        downFirstTime: "", //第一次下班打卡
        upSecondTime: "", //第二次上班打卡时间
        downSecondTime: "", //第二次下班打卡
        addRole: "", //加班规则设置
        timeLimit: "", //打卡时间限制
        allowLate: "" //允许迟到时间
      },
      addRole: [], //加班规则
      timeLimit: [], //打卡时间限制
      clockinDateTitle: "", //添加特殊日期title
      clockinDate: "" //添加特殊日期值
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    //表单头部颜色
    setHeaderStyle() {
      return "background-color: #F2F4FF";
    },
    //查询考勤人员
    departmentFind() {
      this.$post(departmentFind).then(res => {
        if (res.success) {
          this.attendancePerson = res.data;
          this.changeDate();
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //模糊搜索考勤人员
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 选择考勤人员
    choicePerson(val) {
      if (!val.hasOwnProperty("child")) {
        if (this.employeeIds.indexOf(val) === -1) {
          this.employeeIds.push(val);
        }
      } else {
        if (val.child.length > 0) {
          val.child.map(item => {
            this.call(item);
          });
        }
      }
    },
    call(item) {
      if (!item.hasOwnProperty("child")) {
        if (this.employeeIds.indexOf(item) === -1) {
          this.employeeIds.push(item);
        }
      } else {
        if (item.child.length > 0) {
          item.child.map(item => {
            this.call(item);
          });
        }
      }
    },
    changeDate() {
      this.attendancePerson.map(item => {
        if (item.hasOwnProperty("employees") && item.employees.length !== 0) {
          item.employees.map(item1 => {
            item.child.push(item1);
          });
        }
        if (item.hasOwnProperty("child") && item.child.length !== 0) {
          this.callchangeDate(item.child);
        }
      });
    },
    callchangeDate(obj) {
      obj.map(item => {
        if (item.hasOwnProperty("employees") && item.employees.length !== 0) {
          item.employees.map(item1 => {
            item.child.push(item1);
          });
        }
        if (item.hasOwnProperty("child") && item.child.length !== 0) {
          this.callchangeDate(item.child);
        }
      });
    },
    //点击选择考勤人员
    clickPeople() {
      this.dialogTableVisible = true;
      let arr = Object.assign([], this.formData.employeeIds);
      this.employeeIds = arr;
    },
    //选择新增考勤人员
    addPerson() {
      let arr = Object.assign([], this.employeeIds);
      this.formData.employeeIds = arr;
      this.dialogTableVisible = false;
    },
    //通过图标关闭考勤人员弹框
    handleClose(done) {
      this.employeeIds = [];
      done();
    },
    //取消选择新增考勤人员
    addPersonCancel() {
      this.employeeIds = [];
      this.dialogTableVisible = false;
    },
    //删除考勤人员
    deleteAttendancePerson(index) {
      this.employeeIds.splice(index, 1);
    },
    //点击修改考勤时间
    modification(val) {
      this.dialogVisible = true;
      this.timeDTO = Object.assign({}, val);
      this.timeDTO.attendanceDay = this.timeDTO.attendanceDay.split(",");
    },
    //编辑保存考勤时间
    getDate() {
      this.dialogVisible = false;
      this.formData.timeDTO.splice(0, this.formData.timeDTO.length);
      this.formData.timeDTO[0] = Object.assign({}, this.timeDTO);
      this.formData.timeDTO[0].attendanceDay = this.timeDTO.attendanceDay.join(
        ","
      );
    },
    //加班规则
    dicGetvoertimeRule() {
      let params = {
        code: "voertimeRule"
      };
      this.$post(dicGet, params).then(res => {
        this.addRole = res.data;
      });
    },
    //打卡时间限制
    dicGetpunchTimeLimit() {
      let params = {
        code: "punchTimeLimit"
      };
      this.$post(dicGet, params).then(res => {
        this.timeLimit = res.data;
      });
    },
    //添加必须打卡日期/无须打卡日期
    getClockinDate() {
      if (this.clockinDateTitle === "必须打卡日期") {
        this.formData.mustDays.push(this.clockinDate);
      } else if (this.clockinDateTitle === "无须打卡日期") {
        this.formData.notDays.push(this.clockinDate);
      }
      this.dialogVisibleClockinDate = false;
    },
    //删除必须打卡日期
    handleClick(val) {
      this.formData.mustDays.splice(val.$index, 1);
    },
    //删除无须打卡日期
    handleClick1(val) {
      this.formData.notDays.splice(val.$index, 1);
    },
    //取消设置考勤地点弹框
    elDialogRemove() {
      this.dialogVisibleAddress = false;
    },
    //新增考勤地点
    elDialogSave(data) {
      this.formData.spaceDTO.push({
        space: data.address, //地制定位
        longitude: data.lng, //经度
        latitude: data.lat //维度
      });
      this.dialogVisibleAddress = false;
    },
    //删除考勤地点
    deleteAddress(val) {
      this.formData.spaceDTO.splice(val.$index, 1);
    },
    //查询考勤组详情
    queryRuleDetail() {
      let params = { id: sessionStorage.getItem("ruleConfigurationId") };
      this.$post(queryRuleDetail, params).then(res => {
        this.formData = res.data;
        this.formData.timeDTO.attendanceDay = this.formData.timeDTO.attendanceDay.join(
          ","
        );
        let formDataArr = [];
        formDataArr.push(this.formData.timeDTO);
        this.formData.timeDTO = formDataArr;
        this.formData.id = sessionStorage.getItem("ruleConfigurationId");
      });
    },
    //判断新增编辑
    getType() {
      if (sessionStorage.getItem("ruleConfiguration") === "新增") {
        this.url = addRule;
      } else if (sessionStorage.getItem("ruleConfiguration") === "编辑") {
        this.url = updateRule;
        this.queryRuleDetail();
      }
    },
    //保存考勤配置
    save() {
      // debugger
      // console.log(this.formData);
      if (!this.formData.name) {
        this.$message.error("姓名不能为空");
        return;
      }
      if (this.formData.employeeIds.length == 0) {
        this.$message.error("请选择考勤人员");
        return;
      }
      if (this.formData.timeDTO[0].punchNumber == '2') {
        if (!this.formData.timeDTO[0].upFirstTime || !this.formData.timeDTO[0].downFirstTime){
          this.$message.error("请选择打卡时间");
          return;
        }
      }
      if (this.formData.timeDTO[0].punchNumber == '4') {
        if (!this.formData.timeDTO[0].upFirstTime || !this.formData.timeDTO[0].downFirstTime || !this.formData.timeDTO[0].upSecondTime || !this.formData.timeDTO[0].downSecondTime){
          this.$message.error("请选择打卡时间");
          return;
        }

      }
      let params = Object.assign({}, this.formData);
      //考勤人员id
      let newemployeeIds = [];
      params.employeeIds.map(item => {
        newemployeeIds.push(item.id);
      });
      params.employeeIds = newemployeeIds;
      //考勤时间
      params.timeDTO = JSON.stringify(params.timeDTO[0]);
      //考勤地点自定义
      if (params.spaceSetting === "NO" || params.spaceDTO.length === 0) {
        delete params.spaceDTO;
        // delete params.spaceRange;
      } else {
        params.spaceDTO = JSON.stringify(params.spaceDTO);
      }
      this.$post(this.url, params).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.$router.push("/checkingTable");
          this.$store.commit("delete_tabs", "/ruleConfiguration");
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //取消考勤配置
    cancel() {
      this.$router.push("/checkingTable");
    },
    agreeOrnot() {
      this.$confirm(
        "该规则保存后，会立即生效，请确认！",
        "确认保存该规则吗？",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          center: true,
          distinguishCancelAndClose: false
        }
      )
        .then(() => {
          //确定
          this.save();
        })
        .catch(action => { });
    }
  },
  mounted() {
    this.departmentFind();
    this.dicGetvoertimeRule();
    this.dicGetpunchTimeLimit();
    this.getType();
  }
};
</script>
<style lang="less">
.ruleconfiguration {
  .el-input__icon {
    line-height: 25px !important;
  }
  .el-checkbox:last-of-type {
    margin-right: 30px;
  }
  .el-input__inner {
    height: 30px;
  }
  .el-button {
    width: 70px;
    height: 30px;
    background: #f5f5f5;
    color: #666666;
    padding: 0;
    margin-right: 10px;
  }
  .fanwei {
    .el-input__inner {
      height: 22px;
      padding: 0 5px;
    }
  }
  .el-checkbox-group {
    margin: 0;
  }
  .is-checked {
    .el-checkbox__inner {
      background-color: #5e75e6;
      border-color: #5e75e6;
    }
  }
  .is-checked {
    .el-checkbox__label {
      color: #5e75e6;
    }
  }
  .el-dialog {
    .el-dialog__header {
      padding: 20px 30px 0 30px;
    }
    .el-dialog__body {
      .el-time-panel__footer {
        .cancel {
          background: none !important;
          color: #333 !important;
          font-size: 12px !important;
        }
      }
      .out1 {
        padding: 20px 30px 0 30px;
        .el-input__inner {
          width: 200px;
        }
        .tree-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          .el-input {
            width: 200px;
          }
          div {
            min-width: 68px;
          }
        }
        .tree_out {
          display: flex;
          justify-content: space-between;
          .el-tree,
          .selected {
            padding: 10px;
            width: 200px;
            height: 260px;
            border: 1px solid #dcdfe6;
            overflow-y: auto;
          }
          .selected {
            width: 180px;
            line-height: 1.8;
            padding: 10px 15px;
            .selected-item {
              display: flex;
              justify-content: space-between;
            }
            .icon-guanbi {
              color: #999999;
              margin-left: 30px;
              cursor: pointer;
            }
          }
        }
      }
      .clockinout {
        padding: 20px 30px 0 30px;
        .el-input__inner {
          width: 220px;
          padding-left: 30px;
        }
      }
      .dateOut {
        padding: 20px 30px 0 30px;
        .el-input {
          width: 120px;
          height: 26px;
          margin: 0 6px;
          .el-input__prefix {
            display: none;
          }
          .el-input__suffix {
            right: 1px;
            top: 1px;
          }
          .el-input__inner {
            padding: 0 10px;
            height: 26px;
          }
        }
        .item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 20px;
          .label {
            width: 110px;
            text-align: right;
            /*margin-top: 2px;*/
            .must {
              color: #ff0000;
              margin-right: 2px;
            }
          }
          .clockin,
          .clockout {
            margin-right: 20px;
            .el-input {
              width: 70px;
            }
          }
          .dlatetime {
            width: 78px;
            margin: 0 6px;
            .el-input__inner {
              width: 78px;
            }
          }
          .el-checkbox {
            margin-right: 16px;
          }
          .el-radio-button__inner {
            height: 30px;
            line-height: 30px;
            padding: 0 15px;
          }
          .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            background: #5e75e6;
          }
        }
      }
      .dialog-foot {
        text-align: right;
        margin-top: 50px;
        background: #f5f5f5;
        padding: 20px;
        .foot-cancel,
        .foot-save {
          width: 80px;
          height: 40px;
          border: none;
          outline: none;
          border-radius: 4px;
          font-size: 16px;
          color: #ffffff;
          margin-right: 20px;
        }
        .foot-cancel {
          background: #cccccc;
        }
        .foot-save {
          background: #5e75e6;
        }
      }
    }
  }
}
.el-time-panel__content::after,
.el-time-panel__content::before {
  margin-top: -9px !important;
}
.el-time-panel__footer {
  padding: 0;
  .el-time-panel__btn {
    height: 35px !important;
    width: auto;
    background: #ffffff;
  }
}
</style>
<style scoped lang="less">
.ruleconfiguration {
  .title {
    padding: 20px 30px;
    background: #ffffff;
    color: #5e75e6;
    font-size: 18px;
  }
  .content {
    padding: 0 30px 20px 30px;
    background: #ffffff;
    font-size: 14px;
    color: #333333;
    .item {
      display: flex;
      justify-content: flex-start;
      /*align-items: center;*/
      margin-bottom: 18px;
      .label {
        margin-top: 5px;
        .must {
          color: #ff0000;
        }
        .txthidden {
          visibility: hidden;
        }
      }
      .no {
        margin-left: 7.28px;
      }
      .fanwei {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
      }
    }
  }
  .foot {
    margin-top: 50px;
    text-align: right;
    margin-right: 80px;
    margin-bottom: 20px;

    .cancel1,
    .save {
      width: 80px;
      height: 40px;
      border: none;
      border-radius: 4px;
      color: #ffffff;
      background: #999999;
      font-size: 16px;
    }
    .save {
      margin-left: 30px;
      background: #5e75e6;
    }
  }
}
</style>